import { render, staticRenderFns } from "./BTableReports.vue?vue&type=template&id=7da3f4d0&"
import script from "./BTableReports.vue?vue&type=script&lang=js&"
export * from "./BTableReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports